import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOrUpdateResumeGlowUpCompletionMutationVariables = Types.Exact<{
  input: Types.AddOrUpdateResumeGlowUpCompletionInput;
}>;


export type AddOrUpdateResumeGlowUpCompletionMutation = { __typename?: 'Mutation', resumeGlowUpMutations?: { __typename?: 'ResumeGlowUpMutations', addOrUpdateResumeGlowUpCompletion?: { __typename?: 'AddOrUpdateResumeGlowUpCompletionPayload', completions: Array<{ __typename?: 'ResumeGlowUpCompletion', surface: Types.ResumeGlowUpSurface, completionCount: number, firstCompletedTimestamp: number, lastCompletedTimestamp: number }> } | null } | null };


export const AddOrUpdateResumeGlowUpCompletionDocument = gql`
    mutation AddOrUpdateResumeGlowUpCompletion($input: AddOrUpdateResumeGlowUpCompletionInput!) {
  resumeGlowUpMutations {
    addOrUpdateResumeGlowUpCompletion(input: $input) {
      completions {
        surface
        completionCount
        firstCompletedTimestamp
        lastCompletedTimestamp
      }
    }
  }
}
    `;
export type AddOrUpdateResumeGlowUpCompletionMutationFn = Apollo.MutationFunction<AddOrUpdateResumeGlowUpCompletionMutation, AddOrUpdateResumeGlowUpCompletionMutationVariables>;

/**
 * __useAddOrUpdateResumeGlowUpCompletionMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateResumeGlowUpCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateResumeGlowUpCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateResumeGlowUpCompletionMutation, { data, loading, error }] = useAddOrUpdateResumeGlowUpCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrUpdateResumeGlowUpCompletionMutation(baseOptions?: Apollo.MutationHookOptions<AddOrUpdateResumeGlowUpCompletionMutation, AddOrUpdateResumeGlowUpCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrUpdateResumeGlowUpCompletionMutation, AddOrUpdateResumeGlowUpCompletionMutationVariables>(AddOrUpdateResumeGlowUpCompletionDocument, options);
      }
export type AddOrUpdateResumeGlowUpCompletionMutationHookResult = ReturnType<typeof useAddOrUpdateResumeGlowUpCompletionMutation>;
export type AddOrUpdateResumeGlowUpCompletionMutationResult = Apollo.MutationResult<AddOrUpdateResumeGlowUpCompletionMutation>;
export type AddOrUpdateResumeGlowUpCompletionMutationOptions = Apollo.BaseMutationOptions<AddOrUpdateResumeGlowUpCompletionMutation, AddOrUpdateResumeGlowUpCompletionMutationVariables>;